import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const statusApi = createApi({
    reducerPath: 'statusApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["status"],
    endpoints: (builder) => ({
        getStatus: builder.query({
            query: () => { return { url: `status` } },
            providesTags: ["status"],
        }),
        createEditStatus: builder.mutation({
            query: (body) => {
                return {
                    url: "status",
                    method: "POST",
                    body: body
                }
            },
            invalidatesTags: ['status'],
        }),
        deleteStore: builder.mutation({
            query: (guid) => {
                return {
                    url: "status",
                    method: "DELETE",
                    params: {
                        store_guid: guid
                    },
                }
            },
            invalidatesTags: ['status'],
        })
    }),
})

export const { useGetStatusQuery, useCreateEditStatusMutation } = statusApi